import { SupplierRatingState, initialState } from '../state/supplier-rating.state';
import { SupplierRatingActions, GET_PURPOSES_SUCCESS } from '../actions/supplier-rating.action';

export function SupplierRatingReducer(
    state: SupplierRatingState = initialState,
    action: SupplierRatingActions
): SupplierRatingState {
    switch (action.type) {
        case GET_PURPOSES_SUCCESS: {
            return {
                ...state,
                purposes: action.payload
            };
        }

        default: return state;
    }
}